export default "__VITE_ASSET__9b03fa6b__"